import { FC, useState } from 'react';

import { BillOfLadingResponse } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Divider } from '@ravago/shared/radiance/components/divider/components/Divider/Divider';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useBreakpoint } from '@ravago/shared/radiance/hooks/useBreakpoint/useBreakpoint';
import { useTranslations } from '@ravago/shared/translations/client';

interface BolDocumentContentProps {
   data: BillOfLadingResponse;
   onRequestBol: (bol: BillOfLadingResponse) => void;
}

export const BolDocumentContent: FC<BolDocumentContentProps> = ({ data, onRequestBol }) => {
   const translate = useTranslations();
   const [isOrderExpanded, setIsOrderExpanded] = useState(false);
   const { phone, tabPort } = useBreakpoint();
   const filteredOrderLineData = isOrderExpanded ? data.orderLinesData : data.orderLinesData.slice(0, 1);

   return (
      <Box gap="sm" direction="column" width="100%">
         {filteredOrderLineData.map((orderLine, index) => (
            <Box direction={tabPort || phone ? 'column' : 'row'} gap="md" key={orderLine.orderNumber} width="100%">
               {index > 0 && (phone || tabPort) && <Divider />}
               <Box direction="column" gap="none" width={tabPort || phone ? '100%' : '30%'} wrap="wrap">
                  <Typography variant="body-highlight" component="span">
                     {orderLine.productDescription}
                  </Typography>
                  <Typography variant="small" component="span" color="subtle">
                     {`${translate('shipment.documents.order')} ${orderLine.orderNumber}`}
                  </Typography>
               </Box>
               <Box gap="none" width={tabPort || phone ? '100%' : '70%'}>
                  <Box direction="column" gap="none" width={tabPort || phone ? '50%' : '100%'}>
                     {index < 1 && (
                        <>
                           <Typography variant="small" component="span" color="subtle">
                              {translate('shipment.documents.transport-order-number')}
                           </Typography>
                           <Typography variant="small" component="span">
                              {orderLine.transportOrderNr}
                           </Typography>
                        </>
                     )}
                  </Box>
                  <Box items="start" justify="end" width={tabPort || phone ? '50%' : '100%'}>
                     {index < 1 && (
                        <Button variant="tertiary" onClick={() => onRequestBol(data)}>
                           {translate('shipment.documents.request')}
                        </Button>
                     )}
                  </Box>
               </Box>
            </Box>
         ))}
         <Box>
            {data.orderLinesData.length > 1 && (
               <Button
                  variant="tertiary"
                  onClick={() => setIsOrderExpanded(!isOrderExpanded)}
                  trailingIcon={isOrderExpanded ? 'chevron-up' : 'chevron-down'}
               >
                  {isOrderExpanded
                     ? translate('shipment.documents.show-less')
                     : `${data.orderLinesData.length - 1} ${translate('shipment.documents.show-more')} `}
               </Button>
            )}
         </Box>
         {phone && filteredOrderLineData.length > 1 && <Divider />}
      </Box>
   );
};
